import { createFileRoute } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import z from "zod";

import { ReconciliationPage } from "./-components/reconciliation-page";

export const Route = createFileRoute("/operator/reconciliation")({
  component: ReconciliationRoute,
  validateSearch: zodValidator(
    z.object({
      caseId: z.string().min(1).max(128).optional(),
      source: z.enum(["operator_case", "abnormal_event"]).optional(),
    }),
  ),
});

function ReconciliationRoute() {
  const { access } = Route.useRouteContext();
  const { caseId, source } = Route.useSearch();

  return (
    <ReconciliationPage
      permissions={access.permissions}
      initialSelection={caseId && source ? { id: caseId, source } : null}
    />
  );
}
